import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6685fe50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "urls-wrap"
};
const _hoisted_2 = {
  class: "headPath"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "tip"
};
const _hoisted_5 = {
  class: "clikc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAlCAMAAACNkcLAAAAAAXNSR0IArs4c6QAAAeBQTFRFAAAAAAAAAIAAAFUAAEAAAIAAAIBAAGYzAFUqAG0kAHEcAHE5AGYzAF0uAHQuAGoqAHczAHAwAHgtAHErAGsoAHQuAG83AHo3AGo1AHU1AHYxAHY3AGsxAHQ2AHEyAHE5AHM5AHM3AHE1AG40AHQ3AHU1AHI0AHU4AHY2AHM1AHE0AHI3AHA2AHM3AHM1AHQ4AHQ2AHI1AHM2AHE1AHM4AHI2AHQ3AHY2AHQ5AHU3AHI2AHU2AHQ1AHQ3AHM4AHM3AHU2AHM2AHQ3AHI3AHQ2AHQ5AHU4AHQ2AHQ5AHI4AHQ4AHQ3AHU2AHU4AHQ2AHU3AHQ3AHQ5AHM2AHM4AHQ4AHQ4AHM4AHU3AHQ3AHM3AHU4AHU3AHY5AHU5AHQ4AHQ4AHU4AHU4AHQ3AHM3AHU5AHQ4AHU5AHM3AHU4AHU4AHU5AHQ4AHU3AHQ4AHU5AHQ3AHQ5AHQ3AHQ5AHQ4AHQ4AHU4AHU5AHQ3AHQ4AHQ3AHU5AHQ4AHU4AHQ4AHQ4AHU5AHQ4AHU4AHQ5AHQ5AHU5AHQ4AHQ5AHQ5AHU5AHU5AHU4AHQ4AHU5AHQ5AHU4AHU4AHU5AHU5AHQ5AHU4AHU5AHQ5AHQ4AHU4AHQ4AHU5AHU4AHQ4AHQ5AHU4AHQ4AHU5F5gp/gAAAJ90Uk5TAAECAwQEBAUGBwkJCgsLDA8QERITFhcXGBgaHB8hJCQoKissLjAxMjQ1Njg5PD5AQkNHSElMT1BRU1VVVlhbXV5fYWJjY2RnZ2lucHFxdXh5eXp8f4CDg4aHiYuPkJOWlpeYmZmcnZ+fpKaur7KztLi5ub/AwMDBxcbGyMnKzM/R0dPY2Nnb4ODh4+Tl5urs7e7v8PLz9PX29/n6/P3+/zJyOAAAAb9JREFUOMt10ldbE1EUheE1CZiAvYslloAKo6JRYhcbtmhUrFiIwRbFHnsXe8eYqonfX/UiBTJz2FdnP++aZ07ZUqVaTgwVsk8PN8lY1gEofvkK+S6jR8ifnCbNvgxhA6/g9yI1L2v1aWWRqW6/XwprXR5Si9VHv4tn8lmzIJsDKYvP6a0ktZshjfvJfH1jjtNtkoqzWuqjU5/cHuCN4thl3/luimsDP1Ijbqo9Ne8+fXaJx+UNz6oOELNcAW/NP34osf7ui0N+R6Lit6WrADxutJoM3inZcOfiX2IZXraYfVDaBJQozDN6jxSELj3k3Nh+QwqQlKLA98ljevgfwPDEOLbUxgynP2GgwTfA8DVsSX45vYhf8l4A7OoshsdLQa6X/S0bVA7YdQMbXVj2bWTaJDXG6r3y7klZx8i0S/IcNLusXtJLJXkmmF1WL+kO41gEuCdJVoRch9kT5c0eId1u8LWcqZwmQs4QiLK3etxdZJa7/BbB2nozBWdgwZ/3o7rtFDbWse8R+0b3Wyhdmj7SrnrFTW/dB2t+wYPzPaFQKLQ/9hoGmx0/nHQqRa2ebzVdib3j+JVEov9oeG65/w9x0rd3O4sdLAAAAABJRU5ErkJggg==",
  alt: ""
})], -1));
const _hoisted_7 = ["href"];
import nav_header from '@/components/nav_header.vue';
import { adv } from '@/util/http';

import { reactive, toRefs } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    let data = reactive({
      linkArray: []
    });
    let {
      linkArray
    } = toRefs(data);
    adv().then(res => {
      data.linkArray = res.data;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "担保平台",
        iconleft: false
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linkArray), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          src: item.url,
          alt: ""
        }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(item.describe), 1), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, [_createElementVNode("a", {
          style: {
            "color": "#007539"
          },
          href: item.links
        }, "点击访问", 8, _hoisted_7)])])])]);
      }), 128))])])], 64);
    };
  }
};